import { render } from "./FAQsPage.vue?vue&type=template&id=a738e444&scoped=true"
const script = {}

import "./FAQsPage.vue?vue&type=style&index=0&id=a738e444&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a738e444"]])

export default __exports__